import React from 'react';
import { Image } from 'rebass';

import svg from '../../assets/images/logo.svg';

export const Logo = props => <Image {...props} src={svg} width={157} />;

export default Logo;
